import Navbar from './components/Navbar';
import HeroCarousel from './components/HeroCarousel';
import Services from './components/Services';
import CaseShowcase from './components/CaseShowcase';
import ContactForm from './components/ContactForm';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-[#FFF9F0]">
      <Navbar />
      <HeroCarousel />
      <Services />
      <CaseShowcase />
      <ContactForm />
      <Footer />
    </div>
  );
}
